import * as React from 'react';

import Exit from '../FerrariIcon/Exit';
import LinkBullet from '../FerrariIcon/LinkBullet';
import LinkArrow from '../FerrariIcon/LinkArrow';
import NewsArrow from '../FerrariIcon/NewsArrow';
import Documents from '../FerrariIcon/Documents';

import imgSourceCulture from '../../../assets/images/Documenti.png';
import imgSourceSculpture from '../../../assets/images/Documenti2.png';

import s from './FerrariDocuments.module.css';
import LinkCard from '../LinkCard/LinkCard';

// New Header, main section is two divs, first div 2/5 second div 3/5

export default function DocumentsPage(props) {
  const {leavedocs, data} = props;

  const links = data.get('links');
  const about = links.get('about');
  const history = links.get('history');
  const reports = links.get('reports');
  const strategy = links.get('strategy');
  const magazine = links.get('magazine');
  const news = links.get('news');
  const press = links.get('press');
  const sculpture = links.get('sculpture');
  const yearbook = links.get('yearbook');

  return (
    <>
      <div id="ferrari-sub-header" className={s.FerrariSubHeader}>
        <div className={s.TitleWrapper}>
          <Documents />
          <div className={s.SubTitle}>Consult documents</div>
        </div>
        <button className={s.LeaveBtn} onClick={leavedocs}>
          <Exit />
        </button>
      </div>
      <div className={s.MainSection}>
        <div className={s.Corporate}>
          <div className={s.Heading}>Corporate</div>
          <div className={s.CorporateLinks}>
            <a href={about} target="_blank" className={s.LinkWrapper}>
              <div className={s.LinkNameWrapper}>
                <LinkBullet />
                <div className={s.LinkName}>About Us</div>
              </div>
              <LinkArrow />
            </a>
            <a href={history} target="_blank" className={s.LinkWrapper}>
              <div className={s.LinkNameWrapper}>
                <LinkBullet />
                <div className={s.LinkName}>History</div>
              </div>
              <LinkArrow />
            </a>
            <a href={reports} target="_blank" className={s.LinkWrapper}>
              <div className={s.LinkNameWrapper}>
                <LinkBullet />
                <div className={s.LinkName}>Sustainability Report</div>
              </div>
              <LinkArrow />
            </a>
            <a href={strategy} target="_blank" className={s.LinkWrapper}>
              <div className={s.LinkNameWrapper}>
                <LinkBullet />
                <div className={s.LinkName}>Sustainability Strategy</div>
              </div>
              <LinkArrow />
            </a>
          </div>
        </div>
        <div className={s.News}>
          <div className={s.Heading}>News</div>
          <div className={s.NewsLinks}></div>
          <div className={s.NewsBtnWrapper}>
            <a href={news} target="_blank" className={s.StartButtonWrapper}>
              <button className={s.StartButton}>
                Latest news
                <NewsArrow color="yellow" />
              </button>
            </a>
            <a href={press} target="_blank" className={s.StartButtonWrapper}>
              <button className={s.StartButton}>
                Press releases
                <NewsArrow color="yellow" />
              </button>
            </a>
            <a href={magazine} target="_blank" className={s.StartButtonWrapper}>
              <button className={s.StartButton}>
                Magazine
                <NewsArrow color="yellow" />
              </button>
            </a>
          </div>
          <div className={s.LinkCards}>
            <LinkCard
              category="Cars"
              title="Racing Culture"
              description="Introducing the Ferrari Daytona SP3, the stunning new Icona."
              img={imgSourceCulture}
              link={sculpture}
            />
            <LinkCard
              category="Passion"
              title="A very special year"
              description="The 2021 Yearbook is part of a Ferrari tradition."
              img={imgSourceSculpture}
              link={yearbook}
            />
          </div>
        </div>
      </div>
    </>
  );
}
